<div fxLayout>
  <sbnb-subnav header="Direct">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists" fxLayout="column" fxLayoutGap="8px">
    <ng-container *ngTemplateOutlet="headerSection"></ng-container>

    <mat-tab-group class="gvr-tab-group">
      <mat-tab label="Google Vacation Rentals">
        <ng-container *ngTemplateOutlet="googleVRSection"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>

<ng-template #headerSection>
  <section id="header" fxLayout="column">
    <app-feature-flag-tabs>
      <sbnb-page-header class="!mb-0" navTabs>
        <div fxLayout>
          <h2 class="mb-0">Channels</h2>
        </div>
      </sbnb-page-header>
      <div fxLayout>
        <h2 class="mb-0">Channels</h2>
      </div>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'direct-channels'"></sbnb-helptext-wrapper>
  </section>
</ng-template>

<ng-template #googleVRSection>
  <ng-template #loadingProperties>
    <mat-spinner diameter="32"></mat-spinner>
  </ng-template>

  <ng-template *ngIf="isMobile$ | async" [ngTemplateOutlet]="mobileStats"></ng-template>

  <ng-container *ngIf="!(isMobile$ | async)">
    <ng-template [ngTemplateOutlet]="stats"></ng-template>
  </ng-container>

  <ng-template #mobileStats>
    <div *ngIf="gvrStats$ | async as stats">
      <swiper-container
        slides-per-view="1"
        [navigation]="false"
        [pagination]="{ type: 'bullets', clickable: true }"
        [keyboard]="{ enabled: true }"
        class="dialog-image-swiper">
        <swiper-slide>
          <div class="swiper-slide-container">
            <div class="stats-box text-center" fxFlex>
              <h4>Impressions</h4>
              <h1>{{ stats.impressions }}</h1>
              <h5>Last 30 days</h5>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-slide-container">
            <div class="stats-box text-center" fxFlex>
              <h4>Click-through rate</h4>
              <h1>{{ stats.clicks }}</h1>
              <h5>Last 30 days</h5>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-slide-container">
            <div style="display: flex; justify-content: center; align-items: center; height: 100%">
              <div class="stats-box text-center" fxFlex>
                <h4>Bookings</h4>
                <h1>{{ stats.bookings }}</h1>
                <h5>Last 30 days</h5>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>

      <div class="swiper-pagination-bullets"></div>
    </div>
  </ng-template>

  <ng-template #stats>
    <div
      *ngIf="gvrStats$ | async as stats"
      class="stats"
      fxLayout
      fxLayoutGap="32px"
      fxLayout.lt-md="column"
      fxLayoutGap.lt-md="0px">
      <div class="stats-box text-center" fxFlex>
        <h4>Impressions</h4>
        <h1>{{ stats.impressions }}</h1>
        <h5>Last 30 days</h5>
      </div>

      <div class="stats-box text-center" fxFlex>
        <h4>Click-through rate</h4>
        <h1>{{ stats.clicks }}</h1>
        <h5>Last 30 days</h5>
      </div>

      <div class="stats-box text-center" fxFlex>
        <h4>Bookings</h4>
        <h1>{{ stats.bookings }}</h1>
        <h5>Last 30 days</h5>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="properties$ | async as properties; else loadingProperties">
    <div fxLayout="column" fxLayoutGap="32px">
      <div>
        <div class="properties-header rules__rule-header" fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
          <mat-checkbox
            matTooltip="Select all eligible properties"
            [checked]="allEligiblePropertiesSelected(properties)"
            (change)="$event.checked ? selectAllEligibleProperties() : null"></mat-checkbox>
          <span fxFlex>Property name</span>
          <span class="link" (click)="setAllPropertiesAsUnselected()">Clear selection</span>
        </div>

        <div class="properties" fxLayout="column" fxLayoutAlign="start start">
          <div
            *ngFor="let property of properties; let i = index"
            [class.opacity-50]="(property | isPropertyGVREligible).result === 'block'"
            class="rules__rule-container"
            fxLayout
            fxLayoutAlign="start center"
            fxLayoutGap="8px"
            [matTooltip]="
              (property | isPropertyGVREligible).result !== 'block' ? '' : (property | isPropertyGVREligible).notes
            ">
            <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="4px">
              <mat-checkbox
                [disabled]="(property | isPropertyGVREligible).result === 'block'"
                [checked]="
                  (property | isPropertyGVREligible).result === 'block' ? false : property.google_vacation_rentals_sync
                "
                (change)="enableProperty(property, $event)"></mat-checkbox>
              <div fxFlex fxLayout="column">
                <div fxLayoutAlign="start center" fxLayoutGap="8px">
                  <strong class="night-darker ellipsis">{{ property.name }}</strong>

                  <sbnb-cs-debug-item
                    label="Property ID"
                    [coreNovaLink]="'/resources/properties/' + property.id"
                    [value]="property.id.toString()"
                    linkLabel="Nova"></sbnb-cs-debug-item>

                  <div>
                    <!-- <div *ngIf="i === 1" class="badge badge-grass-clear">Pending</div>
                    <div *ngIf="i === 2" class="badge badge-lemon">Issues</div> -->
                  </div>
                </div>
                <div
                  *ngIf="property.google_vacation_rentals_sync && (property | isPropertyGVREligible).result !== 'block'"
                  class="clickable"
                  fxLayoutAlign="start center"
                  fxLayoutGap="2px"
                  matTooltip="Change the Direct site sent to Google"
                  [matMenuTriggerFor]="domainMenu">
                  <span class="text__small night-lighter ellipsis">
                    {{
                      property.google_vacation_rentals_site_id
                        ? (property.google_vacation_rentals_site_id | channelsSiteIdToUrl: property.eligible_sites)
                        : '- Select site -'
                    }}
                  </span>
                  <img src="/assets/iconography/small-arrow-bottom.svg" alt="expand" />
                </div>

                <mat-menu #domainMenu class="domains-menu">
                  <button
                    *ngFor="let site of property.eligible_sites"
                    mat-menu-item
                    (click)="
                      property.google_vacation_rentals_site_id = site.site_id;
                      offerSuggestionToUpdateAllProperties(site, properties)
                    ">
                    <ng-container *ngIf="site.full_url">
                      {{ removeSchemaFromUrl(site.full_url) }}
                    </ng-container>
                  </button>
                </mat-menu>
              </div>
              <div>
                <div class="gvr-status">
                  <a
                    *ngIf="
                      property.gvr?.status === 'live' &&
                      property.gvr?.url &&
                      (property | isPropertyGVREligible).result !== 'block'
                    "
                    [href]="property.gvr.url"
                    target="_blank">
                    <sbnb-button fxHide.lt-lg size="mini" type="primary-teal">View on Google</sbnb-button>
                    <sbnb-button fxHide fxShow.lt-lg size="mini" type="primary-teal">View</sbnb-button>
                  </a>
                  <div
                    *ngIf="property.gvr.status === 'pending'"
                    fxLayoutAlign="start center"
                    fxLayoutGap="6px"
                    [matTooltip]="property.gvr?.issues[0]?.issue">
                    <sbnb-icon icon="time" class="text-grass-darker"></sbnb-icon>
                    <span class="grass-darker text__small">Pending</span>
                  </div>
                  <div
                    *ngIf="property.gvr.status === 'error'"
                    fxLayoutAlign="start center"
                    fxLayoutGap="6px"
                    [matTooltip]="property.gvr?.issues[0]?.issue">
                    <img src="/assets/iconography/warning.svg" />
                    <span class="lemon-darker text__small">Issues</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 24px; height: 36px">
      <sbnb-button
        *ngIf="!saveStatus"
        type="primary"
        size="mini"
        label="Save changes"
        [loading]="saveStatus === 'Saving...'"
        (clicked)="saveChanges(properties)"></sbnb-button>

      <div *ngIf="saveStatus === 'Saved successfully'" fxLayout fxLayoutAlign="start center">
        <mat-icon class="grass-darker">check</mat-icon>
        <span class="grass-darker">Saved</span>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #snackbarTemplate let-data>
  <div fxLayoutAlign="start center" fxLayoutGap="12px" fxLayout.lt-md="column">
    <span class="text__small">
      Would you like to update all other eligible properties to
      <strong>{{ data.site.url }}</strong>
    </span>
    <sbnb-button type="text-secondary" size="mini" (clicked)="barRef.dismiss()">Dismiss</sbnb-button>
    <sbnb-button
      type="primary-teal"
      size="mini"
      (clicked)="updateOtherEligiblePropertiesToSite(data.site, data.properties)">
      Yes
    </sbnb-button>
  </div>
</ng-template>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
